/* eslint-disable global-require */
module.exports = ['marketplace.list.html.m4', 'components.common.gotopage.m1'];
